/** Размер этикетки при печати из приложения для ПК: один принтер, рулоны меняются, поэтому размер выбирается при печати и запоминается */
export interface LabelSize { w: number; h: number }

export const LABEL_SIZES: LabelSize[] = [
  { w: 27, h: 17 }, { w: 30, h: 20 }, { w: 40, h: 25 }, { w: 40, h: 30 },
  { w: 55, h: 37 }, { w: 58, h: 30 }, { w: 58, h: 40 }, { w: 58, h: 60 },
];

const KEY = "label.size.v1";
const DEFAULT: LabelSize = { w: 55, h: 37 };

export const labelSizeKey = (s: LabelSize) => `${s.w}x${s.h}`;

export function getLabelSize(): LabelSize {
  try {
    const raw = localStorage.getItem(KEY);
    const found = LABEL_SIZES.find((s) => labelSizeKey(s) === raw);
    if (found) return found;
  } catch { /* хранилище недоступно — берём размер по умолчанию */ }
  return DEFAULT;
}

export function setLabelSize(key: string) {
  try { localStorage.setItem(KEY, key); } catch { /* не критично: размер просто не запомнится */ }
}
